export const FAQUrl =
  'https://docs.abtasty.com/help-center/troubleshooting/troubleshooting-qa-assistant-doesnt-load-on-my-website';
